<div class="flex-container">
  <div nz-col nzSpan="6" class="page-content--left">
    <form class="filter-form" nz-form>
      <div class="filter-form__header sticky">
        <button class="button float-left" nz-button nzType="secondary" type="button" (click)="emptyFilter()">
          {{ 'integration.ambulance-card.filter.reset' | translate }}
        </button>
        <button class="button float-right" nz-button nzType="primary" (click)="search()" type="submit">
          {{ 'integration.ambulance-card.filter.search' | translate }}
        </button>
      </div>
      <div class="filter-form__body">
        <hw-panel-form-item label="integration.ambulance-card.filter.from" required>
          <hw-date-picker name="from" [(ngModel)]="params.from" [allowClear]="false"></hw-date-picker>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.ambulance-card.filter.to" required>
          <hw-date-picker name="to" [(ngModel)]="params.to" [allowClear]="false"></hw-date-picker>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.ambulance-card.filter.patient">
          <hw-patient-drawer-search
            name="patient"
            [patientName]="patient?.defaultName?.text"
            [(ngModel)]="patient"
            [valuePrimitive]="false"></hw-patient-drawer-search>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.ambulance-card.filter.hospitalization-organization">
          <hw-organization-select
            name="org"
            [(ngModel)]="organization"
            [valuePrimitive]="false"></hw-organization-select>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.ambulance-card.filter.status.title">
          <hw-select name="status" [(ngModel)]="cardStatus">
            <hw-option
              *ngFor="let option of statusOptions"
              label="{{ option.label | translate }}"
              [value]="option.value"></hw-option>
          </hw-select>
        </hw-panel-form-item>
      </div>
    </form>
  </div>
  <nz-content class="page-content--header-inside">
    <hw-page-header header="integration.ambulance-card.data.title" class="page-header"></hw-page-header>
    <div class="page-content__flex-cols-container">
      <div nz-col nzSpan="24">
        <hw-card-list [loading]="loading" [empty]="documents.length === 0">
          <hw-card-list-item *ngFor="let document of documents" style="width: auto; flex-basis: auto">
            <div header>
              <a (click)="openDocument(document)">{{ document.identifier.value }}</a>
            </div>
            <ul>
              <li *ngIf="document.patient?.familyName && document.patient?.givenName">
                <hw-icon code="face" nz-tooltip="{{ 'integration.ambulance-card.data.patient' | translate }}"></hw-icon>
                {{ document.patient.familyName + ', ' + document.patient.givenName }}
              </li>
              <li *ngIf="document.patient?.identifier?.value">
                <hw-icon
                  code="idcard"
                  nz-tooltip="{{ 'integration.ambulance-card.data.personal-code' | translate }}"></hw-icon>
                {{ document.patient.identifier.value }}
              </li>
              <li *ngIf="document.organization">
                <hw-icon
                  code="home"
                  nz-tooltip="{{ 'integration.ambulance-card.data.author-organization' | translate }}"></hw-icon>
                {{ document.organization?.name }}
              </li>
              <li>
                <hw-icon
                  code="field-time"
                  nz-tooltip="{{ 'integration.ambulance-card.data.creation-time' | translate }}"></hw-icon>
                {{ document.createdAt + ' ' + document.createdAtTime }}
              </li>
              <li *ngIf="document.author">
                <hw-icon code="user" nz-tooltip="{{ 'integration.ambulance-card.data.author' | translate }}"></hw-icon>
                {{ document.author?.familyName + ', ' + document.author?.givenName }}
              </li>
              <li>
                <hw-icon code="diff" nz-tooltip="{{ 'integration.ambulance-card.data.version' | translate }}"></hw-icon>
                {{ document.version }}
              </li>
            </ul>
          </hw-card-list-item>
        </hw-card-list>
      </div>
    </div>
  </nz-content>
</div>
